

/**
 *@fileoverview 层
 *@author zhenn
 */

var Base = require('c-base');

var Layer = Base.extend({

    defaults: {
        template: '<div></div>'
    },

    initialize: function initialize() {
        this.Parent.apply(this, arguments);
        // this.create();
    },

    create: function create() {
        var template = this.get('template');
        var el = $(template);

        $(document.body).append(el);
        this.set('el', el);
        this.emit('create', el);
    },

    destroy: function destroy() {
        var el = this.get('el');
        el.remove();
        this.emit('destroy');
    }

});

module.exports = Layer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-layer/dist/index.js
// module id = 7
// module chunks = 0